import {
  LOAD_SONGS_BEGIN,
  LOAD_SONGS_FAILURE,
  LOAD_SONGS_SUCCESS,
  ADD_SONG,
  SAVE_SONG_BEGIN,
  SAVE_SONG_SUCCESS,
  SAVE_SONG_FAILURE,
  EDIT_SONG_NAME,
  EDIT_UPLOAD_STATUS,
  REMOVE_SONG,
  DELETE_SONG_BEGIN,
  BEFORE_SONG_UPLOADED,
  SONG_UPLOADED_TO_SERVER,
  SAMPLE_EDIT,
  SAVE_EVIDENCE_FAILURE,
  SAVE_EVIDENCE_BEGIN,
  SAVE_EVIDENCE_SUCCESS,
  GET_REVIEW_STATES_SUCCESS,
  DELETE_SONG_FAILURE
} from "../actions/songactions";

const initialState = {
  songs: {},
};

const arrayToObject = (array, keyField) =>
  array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});

export function songReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case EDIT_SONG_NAME:
      const editNameSongs = Object.assign({}, nextState.songs);
      const songCopyEditName = Object.assign({}, editNameSongs[action.uniqueName])
      songCopyEditName.songName = action.songName;
      editNameSongs[action.uniqueName] = songCopyEditName;
      const sameAsLoad =
        editNameSongs[action.uniqueName].loadName === action.songName;
      editNameSongs[action.uniqueName].saved = sameAsLoad;
      nextState.songs = editNameSongs;
      return nextState;
    case ADD_SONG:
      const songsCopy = Object.assign({}, nextState.songs);
      const tempKey = Object.keys(state.songs).length;
      songsCopy[tempKey] = {
        songName: "",
        uploadStatus: BEFORE_SONG_UPLOADED,
        localOnly: true,
        loading: false,
        uniqueName: tempKey,
        saved: false,
        reviewStatus: "UNSEEN",
        evidenceUploaded: false,
        dateCreated: Date.now()
      };
      nextState.songs = songsCopy;
      return nextState;
    case EDIT_UPLOAD_STATUS:
      const editUploadStatus = Object.assign({}, nextState.songs);
      const songCopyEditUploadStatus = Object.assign({}, editUploadStatus[action.uniqueName])
      songCopyEditUploadStatus.uploadStatus = action.status;
      songCopyEditUploadStatus.startSecond = 0;
      songCopyEditUploadStatus.endSecond = 20;
      editUploadStatus[action.uniqueName] = songCopyEditUploadStatus;
      nextState.songs = editUploadStatus;
      return nextState;
    case LOAD_SONGS_BEGIN:
      return nextState;
    case LOAD_SONGS_FAILURE:
      return nextState;
    case LOAD_SONGS_SUCCESS:
      nextState.songs = action.songs
        ? arrayToObject(
            action.songs.map((song) => ({
              songName: song.songName,
              loadName: song.songName,
              uploadStatus: SONG_UPLOADED_TO_SERVER,
              localOnly: false,
              loading: false,
              songFileName: song.songFileName,
              startSecond: song.startSecond,
              endSecond: song.endSecond,
              sampleStartByte: song.sampleStartByte,
              sampleEndByte: song.sampleEndByte,
              duration: song.duration,
              fileSize: song.fileSize,
              uniqueName: song.uniqueName,
              reviewStatus: song.reviewInformation != null ? song.reviewInformation.reviewState.status : "UNSEEN",
              evidenceUploaded: song.reviewInformation != null ? song.reviewInformation.reviewState.evidenceUploaded === 'true' : false,
              reason: song.reviewInformation != null ? song.reviewInformation.reviewState.reason : null,
              dateCreated: new Date(song.dateCreated).getTime(),
              saved: true,
              songUrl: song.url,
              ttl: song.ttl
            })),
            "uniqueName"
          )
        : [];
      return nextState;
    case SAVE_EVIDENCE_BEGIN:
      setLoading(nextState, action.uniqueName, true);
      return nextState;
    case SAVE_EVIDENCE_FAILURE:
      setLoading(nextState, action.uniqueName, false);
      return nextState;
    case SAVE_EVIDENCE_SUCCESS:
      setLoading(nextState, action.uniqueName, false);
      nextState.songs[action.uniqueName].evidenceUploaded = true;
      nextState.songs[action.uniqueName].reviewStatus = "IN_REVIEW";
      return nextState;
    case GET_REVIEW_STATES_SUCCESS:
      const getReviewStatesSongsCopy = Object.assign({}, nextState.songs);
      const reviewStatesFiltered = {};
      Object.keys(action.reviewStates).forEach(id => {
        if (action.reviewStates[id].reviewType === "SONG") {
          reviewStatesFiltered[id] = action.reviewStates[id]
        }
      });
      for (const [key, value] of Object.entries(reviewStatesFiltered)) {
        getReviewStatesSongsCopy[key] = Object.assign({}, getReviewStatesSongsCopy[key])
        getReviewStatesSongsCopy[key].evidenceUploaded = value.evidenceUploaded;
        getReviewStatesSongsCopy[key].reviewStatus = value.status;
        getReviewStatesSongsCopy[key].reason = value.reason
      }
      nextState.songs = getReviewStatesSongsCopy;
      return nextState;
    case SAVE_SONG_BEGIN:
      setLoading(nextState, action.uniqueName, true);
      return nextState;
    case SAVE_SONG_FAILURE:
      setLoading(nextState, action.uniqueName, false);
      return nextState;
    case SAVE_SONG_SUCCESS:
      const lastCopy = action.firstSave
        ? state.songs[action.index]
        : state.songs[action.uniqueName];

      const saveSongSongsCopy = Object.assign({}, nextState.songs);
      saveSongSongsCopy[action.uniqueName] = {
        songName: lastCopy.songName,
        uploadStatus: SONG_UPLOADED_TO_SERVER,
        loading: false,
        localOnly: false,
        startSecond: lastCopy.startSecond,
        endSecond: lastCopy.endSecond,
        songFileName: action.songFilename,
        sampleStartByte: action.sampleStartByte,
        sampleEndByte: action.sampleEndByte,
        duration: action.duration,
        fileSize: action.fileSize,
        uniqueName: action.uniqueName,
        reviewStatus: action.reviewStatus,
        evidenceUploaded: false,
        songUrl: action.url,
        ttl: action.ttl,
        dateCreated: new Date(action.dateCreated).getTime(),
        saved: true,
      };
      if (!saveSongSongsCopy[action.uniqueName].startSecond) {
        saveSongSongsCopy[action.uniqueName].startSecond = 0;
        saveSongSongsCopy[action.uniqueName].endSecond = 20;
      }
      if (action.firstSave) {
        delete saveSongSongsCopy[action.index];
      }
      nextState.songs = saveSongSongsCopy;
      return nextState;
    case REMOVE_SONG:
      let removeSongCopy = Object.assign({}, state.songs);

      delete removeSongCopy[action.uniqueName];
      nextState.songs = removeSongCopy;
      return nextState;
    case DELETE_SONG_BEGIN:
      setLoading(nextState, action.uniqueName, true);
      return nextState;
    case DELETE_SONG_FAILURE:
      setLoading(nextState, action.uniqueName, false);
      return nextState;
    case SAMPLE_EDIT:
      const song = Object.assign({}, state.songs[action.uniqueName]);
      song.startSecond = Math.round(song.duration * action.percentage);
      song.endSecond = song.startSecond + 20.0;
      song.saved = false;

      if (action.commit) {
        const startSampleByte =
          song.fileSize * (song.startSecond / song.duration);
        const endSampleByte = song.fileSize * (song.endSecond / song.duration);
        song.sampleStartByte = Math.round(startSampleByte);
        song.sampleEndByte = Math.round(endSampleByte);
      }

      nextState.songs = Object.assign({}, state.songs);
      nextState.songs[action.uniqueName] = song;
      nextState.unsaved = true;

      return nextState;
    default:
      return state;
  }
}

function setLoading(nextState, uniqueName, isLoading) {
  const songsCopy = Object.assign({}, nextState.songs);
  const songCopy = Object.assign({}, songsCopy[uniqueName]);
  songCopy.loading = isLoading;
  songsCopy[uniqueName] = songCopy;
  nextState.songs = songsCopy;
}
